import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';
import validationPatterns from '@glittr/frontend-core/src/plugins/validation/validationPatterns';

const personalDetailsVueSchema = {
  ...queryBuilder.properties({
    companyName: { type: 'string', required: true, maxLength: 150 },
    companyStreet: { type: 'string', required: true, maxLength: 150 },
    companyHouseNumber: { type: 'string', maxLength: 10 },
    companyZIP: {
      type: 'string', required: true, minLength: 1, maxLength: 10,
    },
    companyCity: { type: 'string', required: true, maxLength: 150 },
    website: { type: 'string', maxLength: 255 },
    description: { type: 'string', maxLength: 4000 },
    employeesCount: { type: 'number', minimum: 0 },
    apprenticesCount: { type: 'number', minimum: 0 },
    apprenticeShipsCount: { type: 'number', minimum: 0 },
    professionIds: { type: 'array', minItems: 1, required: true },
    companyContactSalutation: { type: 'integer', required: true },
    companyContactFirstName: { type: 'string', required: true, maxLength: 100 },
    companyContactLastName: { type: 'string', required: true, maxLength: 100 },
    companyContactPhoneNumber: {
      type: 'string', pattern: validationPatterns.phone, required: true, maxLength: 20,
    },
    companyContactEmail: {
      type: 'string', pattern: validationPatterns.email, required: true, maxLength: 255,
    },
    companyLocation: {
      type: 'object',
      required: true,
      properties: {
        longitude: { type: 'number', required: true, maxLength: 19 },
        latitude: { type: 'number', required: true, maxLength: 19 },
      },
    },
  }),
};

export default personalDetailsVueSchema;
